import Swiper from 'swiper';
import { UGC_DISPLAY_TYPE_GALLERY, UGC_DISPLAY_TYPE_ROW } from '../enums/carouselEnums';

import config from '../configs/config';

import {
    getMaxSlidesPerView,
    getMaxSlideCountForSliderView,
    showSliderPagination,
    conditionallyDisplaySliderArrows,
    conditionallyAddMaxImagesClass,
    handleSwiperTransitionStates,
    getInitialSlide
} from '../utils/swiperUtils';

let pdpSlider;

export function showOtherImages(swiper) {
    $(swiper.container[0])
    .parent()
    .parent()
    .find('.o-carousel--hidden').removeClass('o-carousel--hidden');
}

function buildMainSlider() {
    const newPdpSlider = new Swiper(this.scopedSelector('.js-slider--product-image'), {
        wrapperClass: 'o-slider-thumbnails__inner',
        slideClass: 'o-slider-thumbnails__slide',
        nextButton: this.scopedSelector('.js-slider-thumbnails__button--next'),
        prevButton: this.scopedSelector('.js-slider-thumbnails__button--prev'),
        buttonDisabledClass: 'o-slider-thumbnails__button--disabled',
        spaceBetween: 2,
        effect: 'slide',
        loop: false,
        setWrapperSize: true,
        updateTranslate: false,
        slidesPerView: getMaxSlidesPerView(this),
        slidesPerGroup: getMaxSlidesPerView(this),
        direction: 'vertical',
        breakpoints: {
            768: {
                direction: 'horizontal',
                spaceBetween: 0,
                slidesPerView: 4,
                slidesPerGroup: 1
            },
            1024: {
                direction: 'horizontal',
                spaceBetween: 0,
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            1441: {
                direction: 'vertical'
            },
            3000: {
                direction: 'vertical'
            }
        },
        runCallbacksOnInit: true,
        onInit: showOtherImages
    });

    return newPdpSlider;
}

/**
 * get offset height of slider
 * @param {String} context selector string
 */
function getSliderOffsetHeight(context) {
    let carouselHeight = $(context.scopedSelector('.js-carousel-zoom--product-image')).height();

    if (showSliderPagination(context, getMaxSlideCountForSliderView())) {
        carouselHeight = $(context.scopedSelector('.js-main-carousel')).height();
        return (carouselHeight - config.pdpSlider.offsetHeightForControls);
    }
    return (carouselHeight + config.pdpSlider.offsetHeightForDesktop);
}

/**
 * get height of updated slider
 * @param {String} context selector string
 */
function getUpdatedSliderHeight(context) {
    return window.innerWidth > config.pdpSlider.desktopWidth ? getSliderOffsetHeight(context) : 'auto';
}

/**
 * Set pdpSlider height on update
 * @param {String} context selector string
 */
function setUpdatedSliderHeight(context) {
    $(context.scopedSelector('.js-slider--product-image')).height(getUpdatedSliderHeight(context));
}

/* eslint-disable complexity */
export function updateSlider() {
    $('.c-product-video-thumbnail__wrapper').removeClass('c-product-video-thumbnail__wrapper--hidden');

    if (pdpSlider && pdpSlider.height > 0) {
        let sliderDetails = {
            'sliderWrapper': $(this.scopedSelector('.o-slider-thumbnails__wrapper--pdp')),
            'slideCount': $(this.scopedSelector('.o-slider-thumbnails__inner')).children().length
        };

        conditionallyDisplaySliderArrows(getMaxSlideCountForSliderView(), sliderDetails);
        setUpdatedSliderHeight(this);
        conditionallyAddMaxImagesClass(this);
        pdpSlider.update();
    }
}

/* eslint-disable complexity */
/**
 * Initializes swiper
 * @return {object} Contains a referece to the created carousel and slider
 */
export function swiperInitialization() {
    const slideCount = $(this.scopedSelector('.js-carousel-zoom__inner')).children().length;
    const initialSlide = getInitialSlide.bind(this)();

    // Sets to undefined if there is <= 1 slide
    const pdpCarousel =
        slideCount > 1 ?
            new Swiper(this.scopedSelector('.js-main-carousel .js-carousel-zoom--product-image'), {
                initialSlide: initialSlide,
                wrapperClass: 'js-carousel-zoom__inner',
                slideClass: 'js-carousel-zoom__slide',
                bulletClass: 'o-carousel__bullet',
                bulletActiveClass: 'o-carousel__bullet--active',
                pagination: '.js-carousel-zoom__pagination',
                paginationClickable: 'true',
                nextButton: `${this.templateLocation} .js-carousel-zoom__button--next`,
                prevButton: `${this.templateLocation} .js-carousel-zoom__button--prev`,
                buttonDisabledClass: 'o-carousel__button--disabled',
                noSwiping: true,
                noSwipingClass: 'js-carousel-zoom--no-swiping',
                spaceBetween: 1, // UW-12981 On sizes >= 1025 fixes the slide overflow issue
                effect: 'slide',
                loop: true,
                setWrapperSize: true,
                mode: 'horizontal',
                slidesPerView: 1,
                runCallbacksOnInit: true,
                onInit: showOtherImages,
                breakpoints: {
                    1024: {
                        spaceBetween: 0
                    }
                }
            })
            :
            undefined;

    pdpSlider = buildMainSlider.bind(this)();

    const mainImg = $(this.scopedSelector('.js-main-carousel .swiper-slide-active img')).first();

    if (mainImg.length > 0 && mainImg[0].complete) {
        updateSlider.bind(this)();
    } else {
        mainImg.load(() => {
            updateSlider.bind(this)();
        });
    }

    $(window).resize(() => {
        updateSlider.bind(this)();
    });

    const carouselExists = typeof pdpCarousel !== 'undefined' && pdpCarousel.container && pdpCarousel.container.length > 0;
    const sliderExists = typeof pdpSlider !== 'undefined' && pdpSlider.container && pdpSlider.container.length > 0;
    const activeThumbnailClass = 'o-slider-thumbnails__slide--active';

    if (sliderExists && carouselExists) {
        // Upon initialization the initial slide is the active slide loaded
        $(pdpSlider.slides[initialSlide]).addClass(activeThumbnailClass);

        pdpSlider.slideTo(initialSlide);

        // allows slider to act as navigation
        $(document).on('click', this.scopedSelector('.js-slider__slide'), function(event) {
            event.preventDefault();

            $(`.${activeThumbnailClass}`).removeClass(activeThumbnailClass);
            $(this).addClass(activeThumbnailClass);

            const selectedIndex = $(this).index() + 1;

            pdpCarousel.slideTo(selectedIndex);
        });

        // Hide bullets when there are too few
        const numberOfSlides = pdpCarousel.bullets ? pdpCarousel.bullets.length : 0;

        if (numberOfSlides <= 3) {
            $(this.scopedSelector('.o-carousel__pagination--pdp')).hide();
        }

        // allows for pdpCarousel touch/slide to update pdpSlider
        pdpCarousel.on('onSlideChangeEnd', () => {
            // Set adjusted active index due to looping
            const activeIndex = $(pdpCarousel.slides[pdpCarousel.activeIndex]).attr('data-swiper-slide-index');
            const pdpSliderSlides = $('.o-slider-thumbnails__slide');
            const activeSlide = $(pdpSliderSlides[activeIndex]);

            $(`.${activeThumbnailClass}`).removeClass(activeThumbnailClass);
            activeSlide.addClass(activeThumbnailClass);

            pdpSlider.slideTo(activeIndex);
        });
    } else if (sliderExists && !carouselExists) {
        // The slider shouldn't perform any function besides sit there and look pretty
        $(this.scopedSelector('.js-slider__slide')).on('click', (event) => {
            event.preventDefault();
        });
    }

    return { slider: pdpSlider, carousel: pdpCarousel };
}

/* eslint-enable complexity */
// PDP You May Also Like
export function richRelevanceSwiperInit(self, slidesPerView = 3) {
    const slideCount = $(self.scopedSelector('.js-slider-product-tray__inner')).children().length;
    const slidesPerViewForMedium = _.get(self.getState(), 'core.constants.thirdParty.default.rich_relevance.slide_count_for_medium');
    const isShopTheLookProduct = _.get(self.getState(), 'product.productMeta.isShopTheLook', false);
    const maxSlidesForView = isShopTheLookProduct ? 6 : slidesPerViewForMedium;

    if (self.isSwiper && slideCount) {
        const rrSlider = new Swiper(self.scopedSelector('.o-slider-product-tray'), {
            wrapperClass: 'js-slider-product-tray__inner',
            slideClass: 'o-slider-product-tray__slide--product-image',
            buttonDisabledClass: 'o-slider-product-tray__button--disabled',
            nextButton: self.scopedSelector('.js-slider-product-tray__button--next'),
            prevButton: self.scopedSelector('.js-slider-product-tray__button--prev'),
            effect: 'slide',
            speed: 650,
            loop: false,
            setWrapperSize: true,
            slidesPerView: slidesPerView,
            slidesPerGroup: maxSlidesForView,
            breakpoints: {
                1024: {
                    slidesPerView: maxSlidesForView,
                    slidesPerGroup: maxSlidesForView
                },
                767: {
                    slidesPerView: 2.2,
                    slidesPerGroup: 1
                }
            },
            onInit: (swiper) => {
                // Disable previous button by default
                $(self.scopedSelector('.js-slider-product-tray__button--prev')).prop('disabled', true);
            },
            onTransitionEnd: (swiper) => {
                $(self.scopedSelector('.o-slider-product-tray__button')).prop('disabled', false);
                handleSwiperTransitionStates(swiper, self.scopedSelector('.js-slider-product-tray__button--prev'), self.scopedSelector('.js-slider-product-tray__button--next'));
            }
        });
    }
}

/**
 * Swiper for the Product Tray / Split Category module
 * See usage in productTrayComponent
 * @param self
 * @param {String} scopingSelector parent selector string
 * @param {Integer} slidesPerView Slides to show
 * @returns {Object}
 */
export function productTraySwiperInit(scopingSelector, slidesPerView = 3) {
    if ($(`${scopingSelector} .js-slider-product-tray__inner`).children().length) {
        return new Swiper(`${scopingSelector} .o-slider-product-tray`, {
            wrapperClass: 'js-slider-product-tray__inner',
            slideClass: 'js-slider-product-tray__slide',
            nextButton: `${scopingSelector} .js-slider-product-tray__button--next`,
            prevButton: `${scopingSelector} .js-slider-product-tray__button--prev`,
            buttonDisabledClass: 'o-slider__button--disabled',
            effect: 'slide',
            speed: 650,
            loop: false,
            setWrapperSize: true,
            slidesPerView: slidesPerView,
            slidesPerGroup: slidesPerView,
            breakpoints: {
                568: {
                    slidesPerView: 2.2,
                    slidesPerGroup: 1
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                1025: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                },
                1441: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                },
                3000: {
                    slidesPerView: 5,
                    slidesPerGroup: 5
                }
            },
            runCallbacksOnInit: true,
            onInit: (swiper) => {
                let maxSlideCount = 5;
                let sliderDetails = {
                    'sliderWrapper': $(`${scopingSelector} .o-slider-product-tray`).parent('.o-slider-product-tray__wrapper'),
                    'slideCount': $(`${scopingSelector} .o-slider-product-tray__inner`).children().length
                };
                showOtherImages(swiper);
                conditionallyDisplaySliderArrows(maxSlideCount, sliderDetails);
                // Disable previous button by default
                $(`${scopingSelector} .js-slider-product-tray__button--prev`).prop('disabled', true);
            },
            onTransitionEnd: (swiper) => {
                $(`${scopingSelector} .o-slider-product-tray__button`).prop('disabled', false);
                handleSwiperTransitionStates(swiper, `${scopingSelector} .js-slider-product-tray__button--prev`, `${scopingSelector} .js-slider-product-tray__button--next`);
            }
        });
    }
}

/**
 * Swiper for the Specialty Shop Product Tray
 * See usage in productTrayComponent
 * @param self
 * @param {String} scopingSelector parent selector string
 * @param {Integer} slidesPerView Slides to show
 * @returns {Object}
 */
export function specialtyShopTraySwiperInit(scopingSelector, slidesPerView = 3) {

    if ($(`${scopingSelector} .js-slider-product-tray__inner`).children().length) {
        return new Swiper(`${scopingSelector} .o-slider-product-tray`, {
            wrapperClass: 'js-slider-product-tray__inner',
            slideClass: 'js-slider-product-tray__slide',
            nextButton: `${scopingSelector} .js-slider-product-tray__button--next`,
            prevButton: `${scopingSelector} .js-slider-product-tray__button--prev`,
            buttonDisabledClass: 'o-slider__button--disabled',
            effect: 'slide',
            speed: 650,
            loop: false,
            setWrapperSize: true,
            slidesPerView: slidesPerView,
            slidesPerGroup: slidesPerView,
            pagination: `${scopingSelector} .js-slider-product-tray__pagination`,
            paginationType: 'fraction',
            breakpoints: {
                568: {
                    slidesPerView: 2.2,
                    slidesPerGroup: 1,
                    spaceBetween: 20
                },
                767: {
                    slidesPerView: 2.2,
                    slidesPerGroup: 1,
                    spaceBetween: 20
                },
                1025: {
                    slidesPerView: 3.2,
                    slidesPerGroup: 1,
                    spaceBetween: 20
                },
                1441: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 40
                },
                3000: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    slidesPerColumn: 2,
                    spaceBetween: 40
                }
            },
            runCallbacksOnInit: true,
            onInit: (swiper) => {
                let maxSlideCount = 5;
                let sliderDetails = {
                    'sliderWrapper': $(`${scopingSelector} .o-slider-product-tray`).parent('.o-slider-product-tray__wrapper'),
                    'slideCount': $(`${scopingSelector} .o-slider-product-tray__inner`).children().length
                };
                showOtherImages(swiper);
                conditionallyDisplaySliderArrows(maxSlideCount, sliderDetails);
                // Disable previous button by default
                $(`${scopingSelector} .js-slider-product-tray__button--prev`).prop('disabled', true);
            },
            onTransitionEnd: (swiper) => {
                $(`${scopingSelector} .o-slider-product-tray__button`).prop('disabled', false);
                handleSwiperTransitionStates(swiper, `${scopingSelector} .js-slider-product-tray__button--prev`, `${scopingSelector} .js-slider-product-tray__button--next`);
            }
        });
    }
}

export function shopTheLookSwiperInit(store) {
    const shopTheLookSlider = new Swiper(this.scopedSelector('.js-slider--product-image'), {
        wrapperClass: 'o-slider-product-tray__inner',
        slideClass: 'o-slider-product-tray__slide--product-image',
        nextButton: '.o-slider-product-tray__button--next',
        prevButton: '.o-slider-product-tray__button--prev',
        buttonDisabledClass: 'o-slider-product-tray__button--disabled',
        effect: 'slide',
        speed: 650,
        loop: false,
        setWrapperSize: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        breakpoints: {
            640: {
                slidesPerView: 2.2,
                slidesPerGroup: 1
            }
        },
        onInit: (swiper) => {
            // Disable previous button by default
            $(this.scopedSelector('.js-slider-product-tray__button--prev')).prop('disabled', true);
        },
        onTransitionEnd: (swiper) => {
            $(this.scopedSelector('.o-slider-product-tray__button')).prop('disabled', false);
            handleSwiperTransitionStates(swiper, this.scopedSelector('.js-slider-product-tray__button--prev'), this.scopedSelector('.js-slider-product-tray__button--next'));
        }
    });
}

function getUGCGallerySettings() {
    return {
        slidesPerView: 3,
        slidesPerGroup: 3,
        breakpoints: {
            568: {
                slidesPerView: 2.2,
                slidesPerGroup: 1
            },
            768: {
                slidesPerView: 2.2,
                slidesPerGroup: 1
            },
            1025: {
                slidesPerView: 2,
                slidesPerGroup: 2
            },
            1441: {
                slidesPerView: 4,
                slidesPerGroup: 4
            },
            3000: {
                slidesPerView: 4,
                slidesPerGroup: 4
            }
        }
    };
}

function lazyLoadCurrentImage(swiper) {
    const currentSlideIndex = swiper.activeIndex;

    if (currentSlideIndex >= 0 && currentSlideIndex < swiper.slides.length) {
        const currentSlide = swiper.slides[currentSlideIndex];

        const images = $(currentSlide).find('img.js-lazy');

        if (images) {
            $(images).addClass('lazyload');
        }
    }
}

export function ugcTraySwiperInit(store, scopingSelector, displayType, lazy = false) {
    const slideCount = $(`${scopingSelector} .js-slider__inner`).children().length;

    let swiperOptions = {
        wrapperClass: 'o-slider__inner',
        slideClass: 'o-slider__slide--product-image',
        nextButton: `${scopingSelector} .js-slider__button--next`,
        prevButton: `${scopingSelector} .js-slider__button--prev`,
        buttonDisabledClass: 'o-slider__button--disabled',
        effect: 'slide',
        speed: 650,
        loop: false,
        setWrapperSize: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        onInit: (swiper) => {
            // Disable previous button by default
            $(`${scopingSelector} .js-slider__button--prev`).prop('disabled', true);
        },
        onTransitionEnd: (swiper) => {
            $(`${scopingSelector} .o-slider__button`).prop('disabled', false);
            handleSwiperTransitionStates(swiper, `${scopingSelector} .js-slider__button--prev`, `${scopingSelector} .js-slider__button--next`);
        }
    };

    if (displayType === UGC_DISPLAY_TYPE_GALLERY || displayType === UGC_DISPLAY_TYPE_ROW) {
        swiperOptions = Object.assign(swiperOptions, getUGCGallerySettings());
    }

    if (lazy) {
        swiperOptions.onSlideNextStart = lazyLoadCurrentImage;
        swiperOptions.onSlidePrevStart = lazyLoadCurrentImage;
        swiperOptions.onInit = lazyLoadCurrentImage;
    }

    if (slideCount) {
        const ugcTraySwiper = new Swiper(`${scopingSelector} .o-slider--ugc-product-image`, swiperOptions);
    }
}

export function shadowZoomSwiperInit(slideCount, initialSlide, panzoomSelector, getZoomImage) {
    if (slideCount > 1) {
        // Reset pagination
        $(this.scopedSelector('.o-shadow-zoom__button')).show();

        const shadowZoomSwiper = new Swiper(this.scopedSelector('.js-shadow-zoom--product-image'), {
            initialSlide: initialSlide,
            wrapperClass: 'js-carousel-zoom__inner--shadow-zoom',
            slideClass: 'js-carousel-zoom__slide',
            nextButton: `${this.templateLocation} .js-shadow-zoom__button--next`,
            prevButton: `${this.templateLocation} .js-shadow-zoom__button--prev`,
            buttonDisabledClass: 'o-shadow-zoom__button--disabled',
            spaceBetween: 0,
            effect: 'slide',
            loop: true,
            setWrapperSize: true,
            mode: 'horizontal',
            slidesPerView: 1,
            onInit: showOtherImages,
            grabCursor: true,
            onSlideNextStart: (swiper) => {
                if ($(this.scopedSelector()).hasClass('o-shadow-zoom__open')) {
                    const currentSlide = swiper.activeIndex ? swiper.activeIndex - 1 : 0;

                    this.attachLoader(this.store, { onWindow: true });
                    getZoomImage.bind(this)(currentSlide, this, 'js-carousel-zoom__inner--shadow-zoom');
                }
            },
            onSlidePrevStart: (swiper) => {
                const currentSlide = swiper.isBeginning ? swiper.activeIndex + swiper.slides.length - 3 : swiper.activeIndex - 1;

                this.attachLoader(this.store, { onWindow: true });
                getZoomImage.bind(this)(currentSlide, this, 'js-carousel-zoom__inner--shadow-zoom');
            },
            lazyLoading: true
        });
    } else {
        // Hide pagination
        $(this.scopedSelector('.o-shadow-zoom__button')).hide();
    }
}

export default {
    swiperInitialization: swiperInitialization,
    shadowZoomSwiperInit: shadowZoomSwiperInit,
    showOtherImages: showOtherImages,
    updateSlider: updateSlider
};
